import { cn } from '@/shared/lib/cn'
import type { DueDateInput } from '@/shared/lib/due-date'
import { useI18n } from '@/shared/i18n'
import { toDate } from '@/shared/lib/format'

export interface RelativeTimeProps {
  value: DueDateInput
  timeZone?: string
  /**
   * Umbral de frescura en horas. Pasado ese punto el dato se muestra atenuado
   * con la fecha real en vez de fingir que esta fresco (caso `synced_at` de los
   * repos: nunca se borra lo ultimo que sabiamos, pero tampoco se miente).
   */
  staleAfterHours?: number
  className?: string
}

export function RelativeTime({ value, timeZone, staleAfterHours, className }: RelativeTimeProps) {
  const { formatDateTime, formatRelative } = useI18n()
  const date = toDate(value)
  if (!date) return <span className={cn('text-text-3', className)}>—</span>

  const absolute = formatDateTime(date, timeZone)
  const ageHours = (Date.now() - date.getTime()) / 3_600_000
  const isStale = staleAfterHours !== undefined && ageHours > staleAfterHours

  return (
    <time
      dateTime={date.toISOString()}
      title={absolute}
      className={cn('num text-xs', isStale ? 'text-text-3' : 'text-text-2', className)}
    >
      {isStale ? absolute : formatRelative(date)}
    </time>
  )
}
